export function isExecutorWizardReturn(route) {
  return route.query.returnTo === 'executor-wizard'
}

export function returnToExecutorWizard(router) {
  return router.push({ name: 'ExecutorWizardHub' })
}

export function refreshWizardItem(wizard, route, item) {
  const model = route.query.wizardModel
  if (isExecutorWizardReturn(route) && model && item) {
    wizard.setItem(model, item)
  }
}
